import React from "react";
import styles from "./HomeCard.module.scss";
import classnames from "classnames";

const HomeCard: React.FC = ({ children }) => {
    return (
        <div className={classnames("card", styles.card)}>
            <div className="card-body">{children}</div>
        </div>
    );
};

export default HomeCard;
